import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(dev)/themes/")({
  component: ThemeIndexComponent,
});

function ThemeIndexComponent() {
  return <div>Hello "/(dev)/themes/"!</div>;
}
